import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import {AuthenticationService} from "../../services/auth.service";
import { Router, RouterLink } from "@angular/router";
import { NoFrameComponent } from '../../frames/no-frame/no-frame.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { KazButtonComponent } from '../../components/kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NoFrameComponent, FaIconComponent, KazButtonComponent, RouterLink]
})
export class InfoComponent implements OnInit {
  private _auth = inject(AuthenticationService);
  private _router = inject(Router);


  ngOnInit() {
    this.isAuthenticated();
  }

  isAuthenticated() {
    if (this._auth.isAuthenticated()) {
      this._router.navigate(['profile']).then();
    }
  }
}
